import script from "./PaginacaoGex.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginacaoGex.vue?vue&type=script&setup=true&lang=js"

import "./PaginacaoGex.vue?vue&type=style&index=0&id=0c4f6a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4f6a1e"]])

export default __exports__